@if (isVisible) {
  <div class="modal-overlay">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title">
            <i class="fa fa-cog"></i>
            Field Parameters
          </h2>
        </div>
        <div class="modal-body">
          <form class="form-horizontal">
            <div class="form-group">
              <label class="col-sm-5 control-label">Max Field Size:</label>
              <div class="col-sm-7">
                <input type="number" class="form-control" [(ngModel)]="form.maxFieldSize" name="maxFieldSize" min="0" />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-5 control-label">A Bracket Size:</label>
              <div class="col-sm-7">
                <input type="number" class="form-control" [(ngModel)]="form.aBracketSize" name="aBracketSize" min="0" />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-5 control-label">B Bracket Size:</label>
              <div class="col-sm-7">
                <input type="number" class="form-control" [value]="bBracketSize" readonly disabled />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-5 control-label">C Bracket Size:</label>
              <div class="col-sm-7">
                <input type="number" class="form-control" [(ngModel)]="form.cBracketSize" name="cBracketSize" min="0" />
              </div>
            </div>
            @if (bBracketSize < 0) {
              <div class="alert alert-warning">
                <i class="fa fa-exclamation-triangle"></i>
                The calculated B Bracket size cannot be negative. Adjust A or C values.
              </div>
            }
            @if (bBracketSize >= 0) {
              <div class="alert alert-info">
                <i class="fa fa-info-circle"></i>
                B Bracket is calculated automatically as Max Field - A - C.
              </div>
            }
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeModal()">
            <i class="fa fa-times"></i> Cancel
          </button>
          <button type="button" class="btn btn-primary" (click)="save()">
            <i class="fa fa-save"></i> Save
          </button>
        </div>
      </div>
    </div>
  </div>
}
